'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tagsInputClearTrigger = require('./tags-input-clear-trigger.cjs');
const tagsInputContext = require('./tags-input-context.cjs');
const tagsInputControl = require('./tags-input-control.cjs');
const tagsInputHiddenInput = require('./tags-input-hidden-input.cjs');
const tagsInputInput = require('./tags-input-input.cjs');
const tagsInputItem = require('./tags-input-item.cjs');
const tagsInputItemContext = require('./tags-input-item-context.cjs');
const tagsInputItemDeleteTrigger = require('./tags-input-item-delete-trigger.cjs');
const tagsInputItemInput = require('./tags-input-item-input.cjs');
const tagsInputItemPreview = require('./tags-input-item-preview.cjs');
const tagsInputItemText = require('./tags-input-item-text.cjs');
const tagsInputLabel = require('./tags-input-label.cjs');
const tagsInputRoot = require('./tags-input-root.cjs');
const tagsInputRootProvider = require('./tags-input-root-provider.cjs');



exports.ClearTrigger = tagsInputClearTrigger.TagsInputClearTrigger;
exports.Context = tagsInputContext.TagsInputContext;
exports.Control = tagsInputControl.TagsInputControl;
exports.HiddenInput = tagsInputHiddenInput.TagsInputHiddenInput;
exports.Input = tagsInputInput.TagsInputInput;
exports.Item = tagsInputItem.TagsInputItem;
exports.ItemContext = tagsInputItemContext.TagsInputItemContext;
exports.ItemDeleteTrigger = tagsInputItemDeleteTrigger.TagsInputItemDeleteTrigger;
exports.ItemInput = tagsInputItemInput.TagsInputItemInput;
exports.ItemPreview = tagsInputItemPreview.TagsInputItemPreview;
exports.ItemText = tagsInputItemText.TagsInputItemText;
exports.Label = tagsInputLabel.TagsInputLabel;
exports.Root = tagsInputRoot.TagsInputRoot;
exports.RootProvider = tagsInputRootProvider.TagsInputRootProvider;
